<template>
    <div>
        <b-card class="full-width" style="height: 550px">
            <ValidationObserver v-slot="{ invalid }" ref="observer">
                <div slot="header" class="mt-1">
                    <h2 class="view-header-class">Create Subscription</h2>
                </div>
                <router-link
                    :to="{ name: 'view-subscription' }"
                    style="
                        color: white;
                        text-decoration: none;
                        float: right;
                        margin-top: -40px;
                    "
                >
                    <strong class="mr-1 btn btn-success">Back</strong>
                </router-link>
                <b-row class="mt-4">
                    <b-col md="6">
                        <label class="">Subscription Plan </label>
                        <ValidationProvider
                            rules="required"
                            v-slot="{ errors }"
                            name="Subscription Plan"
                        >
                            <eb-select
                                label="label"
                                class="w-75"
                                :options="subscriptionOptions"
                                v-model="selectPlan"
                                placeholder="Select Subscription Plan"
                            ></eb-select>
                            <span class="validate-error">{{ errors[0] }}</span>
                        </ValidationProvider>
                    </b-col>

                    <b-col md="6">
                        <label> Plan Details </label>
                        <c-input
                            type="text"
                            class="w-75"
                            inputId="details"
                            
                            :value="planDetails"
                            lableText="Plan Details"
                        />
                    </b-col>
                </b-row>
                <br />
                <b-row>
                    <b-col md="6">
                        <!-- <v-radio-group v-model="selected" row class="ml-5">
                <v-radio  color="primary" label="Price Override" value="price">
                  <template v-slot:label>
                    <div class="mt-1">Price Override</div>
                  </template>
                </v-radio>
                <v-radio
                  color="primary"
                  label="Discount Percent"
                  value="discount"
                >
                  <template v-slot:label>
                    <div class="mt-1">Discount Percent</div>
                  </template>
                </v-radio>
              </v-radio-group> -->
                        <b-form-group>
                            <b-form-radio-group
                                id="radio-group-2"
                                v-model="selected"
                                stacked
                            >
                                <b-form-radio size="lg" value="price"
                                    ><span style="margin: 13px; font-size: 16px"
                                        >Price Override</span
                                    ></b-form-radio
                                >
                                <b-form-radio size="lg" value="discount"
                                    ><span style="margin: 13px; font-size: 16px"
                                        >Discount Percent</span
                                    ></b-form-radio
                                >
                            </b-form-radio-group>
                        </b-form-group>
                    </b-col>
                    <b-col md="6">
                        <c-input
                            v-if="selected == 'price'"
                            inputType="number"
                            class="w-75"
                            :inputId="`price`"
                            v-model="takePriceInput"
                            lableText="Price Override"
                        />
                        <c-input
                            v-if="selected == 'discount'"
                            inputType="number"
                            class="w-75"
                            :inputId="`discount`"
                            v-model="takeDiscountInput"
                            lableText="Discount Percent"
                        />
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="6">
                        <strong class="">Activation Date</strong>
                        <b-input
                            id="activation-date"
                            type="date"
                            v-model="activationDate"
                            disabled
                        ></b-input>
                    </b-col>
                </b-row>
                <div class="text-center mt-4">
                    <b-button
                        btn-special="primary3"
                        class="footer-bottons-class mr-5"
                        @click="assignSubscription()"
                        size="lg"
                        :disabled="invalid"
                    >
                        Save
                    </b-button>
                </div>
            </ValidationObserver>
        </b-card>
    </div>
</template>
<script>
import ebSelect from "@/components/FormElements/Select";
import cInput from "@/components/Common/CustomInput";
import ebButton from "@/components/FormElements/Button";
import { mapGetters, mapState } from "vuex";
import moment from "moment";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { subscriptionList } from "@/services/subscription";
export default {
    name: "CreateSubscription",
    components: {
        ebSelect,
        cInput,
        ebButton,
        ValidationObserver,
        ValidationProvider,
    },
    data() {
        return {
            selectPlan: null,
            selected: null,
            takePriceInput: "",
            takeDiscountInput: "",
            subscriptionOptions: [],
            activationDate: moment().format("yyyy-MM-DD"),
        };
    },
    computed: {
        ...mapGetters({
            partnerAllData: "partner/getPartnerData",
        }),
        ...mapState({
            subscriptionList: (state) =>
                state.subscription.tenantSubscriptionList.reverse(), 
        }),
        planDetails() {
            if (this.selectPlan) {
                if (this.selectPlan.value.pricing.uom == "OCCURRENCE") {
                    return (
                        "PRICE : " +
                        this.selectPlan.value.pricing.cadence +
                        " " +
                        this.selectPlan.value.pricing.currency +
                        " " +
                        this.selectPlan.value.pricing.price
                    );
                } else if (
                    this.selectPlan.value.pricing.cadence == "EVENT" &&
                    this.selectPlan.value.pricing.eventType == "ORDER_FULFILLED"
                ) {
                    return (
                        "PRICE : " +
                        this.selectPlan.value.pricing.price * 100 +
                        "%" +
                        " OF ORDER " +
                        this.selectPlan.value.pricing.uom
                    );
                } else if (
                    this.selectPlan.value.pricing.cadence == "EVENT" &&
                    this.selectPlan.value.pricing.eventType == "DELIVERY_CHARGE"
                ) {
                    return (
                        "PRICE : " +
                        this.selectPlan.value.pricing.price * 100 +
                        "%" +
                        " OF ORDER " +
                        this.selectPlan.value.pricing.uom
                    );
                }
            } else {
                return null;
            }
        },
    },
    methods: {
        isValid() {
            const isValid = this.$refs.observer.validate();
            this.$emit("isValid", isValid);
            return isValid;
        },
       async getList() {
    try {
      await this.$store.dispatch("subscription/getSubscriptionListTenantAction");

    } catch (error) {
    }
  },
        async assignSubscription() {
            const isValid = await this.isValid();

            if (!isValid) {
                return;
            }
            if (!this.selectPlan) {
                this.$swal({
                    title: "Failed",
                    text: "Opps !!!!...Select Plan First",
                    type: "error",
                });
                return;
            }
                const userId = this.partnerAllData?._id || this.$route.params.id;
                if (!userId) {
                    this.$swal({
                        title: "Error",
                        text: "User ID not found",
                        type: "error",
                    });
                    return;
                }
                let payload={
                    user:userId,
                    discount:"",
                    discountType:"",
                    plan: this.selectPlan.value._id,
                    activationDate:moment(this.activationDate).format("DD/MM/YYYY"),
                };
                if (this.selected == "price") {
                    payload.discount = this.takePriceInput;
                    payload.discountType = "PRICE";
                } else if (this.selected == "discount") {
                    payload.discount = this.takeDiscountInput;
                    payload.discountType = "PERCENTAGE";
                } else {
                    delete payload.discount;
                    delete payload.discountType;
                }
                try{
                    await this.$store.dispatch("subscription/assignSubscriptionList", payload);
                    this.$swal({
                        title: "Added",
                        text: "Subscription Plan Assigned Successfully!",
                        type: "success",
                        confirmationButtonText: "OK",
                    });
                    this.$router.push({
                        name: "view-subscription",
                        params: { id: this.$route.params.id },
                    });
                } catch (error) {
                    this.$swal({
                        title: "Sorry",
                        text: "Unable to Assign Subscription Plan",
                        type: "error",
                    });
                }
        }
    },
    async mounted() {
  await this.getList();
  let allOptions = this.subscriptionList.map((element) => ({
    label: element.planName,
    value: element
  }));
  this.subscriptionOptions = allOptions;
}
};
</script>
<style>
[btn-special="primary3"] {
    border: 0px;
    font-weight: 500;
    letter-spacing: 1px;
    font-size: medium;
    font-family: "Lato";
    border-radius: 0px;
    height: 39px;
    width: 132px;
    background-color: var(--primary);
    color: white;
}
.custom-control-label::after {
    position: absolute;
    top: 0.15625rem;
    left: -1.5rem;
    display: block;
    width: 1.4rem;
    height: 1.4rem;
    content: "";
    background: no-repeat 50%/50% 50%;
}
.custom-control-label::before {
    position: absolute;
    top: 0.15625rem;
    left: -1.5rem;
    display: block;
    width: 1.4rem;
    height: 1.4rem;
    pointer-events: none;
    content: "";
    background-color: #fff;
    border: #000000 solid 2px;
}
</style>
